import { useEffect, useMemo, useState } from "react"
import AptUnitEditPanel from "./apt-unit-edit-panel"
import { aptUnitSizeStore } from "../apt-unit-size-store"
import { LOCKED_SIZE } from "@/routes/admin/admin-const"

const AptUnitEditorModal = ({ dong, unitMap = {}, palette = {} }) => {
  const CELL_WIDTH = 80
  const CELL_HEIGHT = 30

  const { maxFloor, maxHo, setMaxFloor, setMaxHo, selectedSize } = aptUnitSizeStore()

  const [editPalette, setEditPalette] = useState({})
  const [editUnitMap, setEditUnitMap] = useState({})
  const [isPainting, setIsPainting] = useState(false)

  const [mode, setMode] = useState("EDIT")

  useEffect(() => {
    if (mode !== "create") setEditPalette(palette)

    // ! 없을 경우 신규 생성으로 생각
    if (Object.keys(unitMap).length === 0) {
      setMode("create")
      return
    }

    setEditUnitMap(unitMap)

    const unitNos = Object.keys(unitMap).map(Number)

    if (unitNos.length > 0) {
      const floors = unitNos.map((v) => Math.floor(v / 100))
      const hos = unitNos.map((v) => v % 100)

      setMaxFloor(Math.max(...floors))
      setMaxHo(Math.max(...hos))
    }
  }, [palette, unitMap])

  const floors = useMemo(() => {
    return Array.from({ length: maxFloor }, (_, i) => maxFloor - i)
  }, [maxFloor])

  const hos = useMemo(() => {
    return Array.from({ length: maxHo }, (_, i) => i + 1)
  }, [maxHo])

  const paintUnit = (floor, ho) => {
    const unitNo = floor * 100 + ho

    setEditUnitMap((prev) => {
      const next = { ...prev }

      // 사용 안함
      if (selectedSize === null) {
        delete next[unitNo]
        return next
      }

      // 필로티 토글
      if (selectedSize === LOCKED_SIZE && next[unitNo] === LOCKED_SIZE) {
        delete next[unitNo]
        return next
      }

      next[unitNo] = selectedSize

      return next
    })
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="w-[90vw] h-[90vh] bg-white rounded-2xl flex overflow-hidden">
        {/* SVG */}
        <section className="flex-1 flex items-center justify-center overflow-auto p-6">
          <svg
            width={maxHo * CELL_WIDTH}
            height={maxFloor * CELL_HEIGHT}
            onMouseUp={() => setIsPainting(false)}
            onMouseLeave={() => setIsPainting(false)}
          >
            {floors.map((floor, yIdx) =>
              hos.map((ho, xIdx) => {
                const unitNo = floor * 100 + ho

                const size = editUnitMap[unitNo]

                const color = size === LOCKED_SIZE ? "#ffffff" : (editPalette[size] ?? "#f3f4f6")

                return (
                  <g
                    key={unitNo}
                    className="cursor-pointer select-none"
                    onMouseDown={() => {
                      setIsPainting(true)
                      paintUnit(floor, ho)
                    }}
                    onMouseEnter={() => {
                      if (isPainting) {
                        paintUnit(floor, ho)
                      }
                    }}
                  >
                    <rect
                      x={xIdx * CELL_WIDTH}
                      y={yIdx * CELL_HEIGHT}
                      width={CELL_WIDTH - 2}
                      height={CELL_HEIGHT - 2}
                      fill={color}
                      stroke="#d1d5db"
                    />

                    <text
                      x={xIdx * CELL_WIDTH + CELL_WIDTH / 2}
                      y={yIdx * CELL_HEIGHT + CELL_HEIGHT / 2 + 4}
                      textAnchor="middle"
                      fontSize={11}
                    >
                      {unitNo}
                    </text>

                    {size === LOCKED_SIZE && (
                      <>
                        <line
                          x1={xIdx * CELL_WIDTH + 8}
                          y1={yIdx * CELL_HEIGHT + 8}
                          x2={xIdx * CELL_WIDTH + CELL_WIDTH - 8}
                          y2={yIdx * CELL_HEIGHT + CELL_HEIGHT - 8}
                          stroke="#d0d0d0"
                          strokeWidth={2}
                        />

                        <line
                          x1={xIdx * CELL_WIDTH + CELL_WIDTH - 8}
                          y1={yIdx * CELL_HEIGHT + 8}
                          x2={xIdx * CELL_WIDTH + 8}
                          y2={yIdx * CELL_HEIGHT + CELL_HEIGHT - 8}
                          stroke="#d0d0d0"
                          strokeWidth={2}
                        />
                      </>
                    )}
                  </g>
                )
              })
            )}
          </svg>
        </section>

        <AptUnitEditPanel
          dong={dong}
          mode={mode}
          originPalette={palette}
          editPalette={editPalette}
          setEditPalette={setEditPalette}
          unitMap={editUnitMap}
          setEditUnitMap={setEditUnitMap}
        />
      </div>
    </div>
  )
}

export default AptUnitEditorModal
